import { ReactElement } from 'react';

import { Category } from '@/helpers/gameCategories';

export type NavItem = string | ReactElement | Category;

export const isCategory = (navItem: NavItem): navItem is Category => {
  const category = navItem as Category;

  return category.title !== undefined && category.id !== undefined;
};
